const actionTypes = {
    SET_BOX_STATE: "SET_BOX_STATE"
};

export const setBoxState = (boxid, state) => {
    return {type: actionTypes.SET_BOX_STATE, boxid, state}
}

export default actionTypes;